import { render, staticRenderFns } from "./Aprobados.vue?vue&type=template&id=750a0a91&"
import script from "./Aprobados.vue?vue&type=script&lang=js&"
export * from "./Aprobados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports